/**
 * Хранение состояния предложения включить пуши (localStorage).
 * Значения — время в мс. Старое значение "1" (до появления напоминаний)
 * считаем временем первого чтения, чтобы напоминание не вылезло сразу.
 */
const DISMISSED_KEY = "push-prompt-dismissed";
const DENIED_SINCE_KEY = "push-denied-since";

/** Через сколько повторно напоминать о пушах. */
export const PUSH_REMIND_INTERVAL_DAYS = 60;
const REMIND_INTERVAL_MS = PUSH_REMIND_INTERVAL_DAYS * 24 * 60 * 60 * 1000;

const readTime = (key: string): number | null => {
  const raw = localStorage.getItem(key);
  if (raw === null) {
    return null;
  }

  const value = Number(raw);
  if (!Number.isFinite(value) || value < 1e12) {
    const now = Date.now();
    localStorage.setItem(key, String(now));
    return now;
  }

  return value;
};

const writeNow = (key: string) => {
  localStorage.setItem(key, String(Date.now()));
};

export const isPushPromptDismissed = (): boolean =>
  readTime(DISMISSED_KEY) !== null;

export const dismissPushPrompt = () => writeNow(DISMISSED_KEY);

/**
 * Пора ли показать напоминание:
 * - default — только если блок на главной скрыт «Не сейчас»;
 * - denied — отсчёт с первого захода, когда увидели запрет.
 * Интервал считается от скрытия/первого запрета или прошлого напоминания.
 */
export const shouldRemindAboutPush = (
  permission: NotificationPermission,
): boolean => {
  if (permission !== "denied") {
    localStorage.removeItem(DENIED_SINCE_KEY);
  }

  if (permission === "granted") {
    return false;
  }

  const key = permission === "denied" ? DENIED_SINCE_KEY : DISMISSED_KEY;
  const since = readTime(key);

  if (since === null) {
    if (permission === "denied") {
      writeNow(DENIED_SINCE_KEY);
    }
    return false;
  }

  return Date.now() - since >= REMIND_INTERVAL_MS;
};

export const markPushReminded = (permission: NotificationPermission) => {
  writeNow(permission === "denied" ? DENIED_SINCE_KEY : DISMISSED_KEY);
};
